<template>
    <div class="efficiency-graph">
        
        <div class="placeholder">
            <graph-card
                heading="Hvor meget tid bruger svendene hos kunderne?"
                unit="%"
                ylabel="Timer brugt på kundeopgaver"
                height="450"
                :trend="true"
                :endpoint="efficiencyGraph"
                :paramsInEndpoint="efficiencyGraphParams"
                :series="efficiencyGraphSeries"
            >
            <button style="position:absolute;top:0;right:0;line-height:50px;margin-right:15px;outline:none;" @click="toggleEfficiency()">
                <span v-if="efficiencyGraph === 'efficiency'">
                    Vis fordeling pr. ugedag
                </span>
                <span v-else-if="efficiencyGraph === 'efficiency?weekdays=1'">
                    Vis fordeling pr. måned
                </span>
            </button>
            </graph-card>
        </div>

    </div>
</template>

<script>
export default {
    data () {
        return {
            efficiencyGraph: 'efficiency',
            efficiencyGraphParams: false,
            efficiencyGraphSeries: [{'name': 'Arbejde hos kunderne', 'type': 'bar', 'width': 0}]
        }
    },
    methods: {
        toggleEfficiency () {
            if (this.efficiencyGraph === 'efficiency') {
                this.efficiencyGraph = 'efficiency?weekdays=1'
                this.efficiencyGraphParams = true
            } else {
                this.efficiencyGraph = 'efficiency'
                this.efficiencyGraphParams = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// efficiencyGraph.vue?b58db7d8